import { render, staticRenderFns } from "./ListReservations.vue?vue&type=template&id=bb3bda04&"
import script from "./ListReservations.vue?vue&type=script&lang=js&"
export * from "./ListReservations.vue?vue&type=script&lang=js&"
import style0 from "./ListReservations.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports